import type { PostOnIdealistDropdownData } from '#/components/PostOnIdealistDropdown/types/PostOnIdealistDropdownData';
import { createOrgRoute, postAListingRoute } from '#/routing/routes';

export const postOnIdealistDropdownDataEn: PostOnIdealistDropdownData = {
  search: {
    title: 'Post',
    items: [
      {
        type: 'post-a-listing',
        title: 'Post a Listing',
        href: postAListingRoute.with({}),
      },
      {
        type: 'create-org',
        title: 'Add your Organization',
        href: createOrgRoute.with({}),
      },
    ],
  },
  resources: {
    title: 'Resources',
    items: [
      {
        type: 'employer-resources',
        title: 'Employer Resources',
        description:
          'Tools and advice to help you achieve your hiring and retention goals.',
        href: '/en/orgs/resources',
      },
      {
        type: 'volunteer-resources',
        title: 'Volunteer Engagement Resources',
        description:
          'Trainings and proven practices to help you successfully recruit and engage volunteers.',
        href: '/en/orgs/volunteer-engagement-resources',
      },
    ],
  },
};
